import React from 'react';
import { SKILLS } from '../data/sectionsData';

export default function SkillsSection() {
    return (
        <section className="py-16 md:py-24 px-4 md:px-6 max-w-[1200px] mx-auto" id="skills">
            <div className="mb-16 reveal">
                <span className="inline-flex items-center gap-2 px-4 py-1.5 bg-primary-container text-on-primary-container rounded-full text-[0.8125rem] font-semibold uppercase tracking-widest mb-4">
                    <i className="fa-solid fa-cubes"></i> Skills
                </span>
                <h2 className="text-[clamp(1.75rem,4vw,2.75rem)] font-bold tracking-tight text-on-surface mb-2">My Toolbox</h2>
                <p className="text-[1.0625rem] text-on-surface-variant max-w-[560px] leading-relaxed">
                    Technologies and tools I've worked with to bring ideas to life.
                </p>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
                {SKILLS.map((cat, ci) => (
                    <div
                        key={ci}
                        className={`bg-surface-container rounded-2xl p-6 shadow-1 hover:shadow-2 hover:-translate-y-0.5 transition-all duration-400 ease-emphasized reveal reveal-delay-${Math.min(ci + 1, 4)}`}
                    >
                        <h3 className="text-[0.8125rem] font-semibold uppercase tracking-widest text-on-surface-variant mb-4 pb-2 border-b border-outline-variant">
                            {cat.category}
                        </h3>
                        <div className="flex flex-wrap gap-2">
                            {cat.items.map((skill, si) => (
                                <div
                                    key={si}
                                    className="skill-chip inline-flex items-center gap-2 px-4 py-2 bg-surface-variant rounded-full text-sm font-medium text-on-surface hover:bg-primary-container hover:text-on-primary-container hover:-translate-y-0.5 hover:shadow-1 transition-all duration-200 ease-standard cursor-default"
                                >
                                    <i className={`${skill.icon} text-lg w-5 text-center transition-transform duration-200 hover:scale-[1.2]`} style={{ color: skill.color }}></i>
                                    <span>{skill.name}</span>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}
            </div>
        </section>
    );
}
